import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { styled } from '@mui/material/styles';

function DataTable({ title, data,type }) {


    var lengthArray = data.map(t=> Object.keys(t).length)
    var maxArray = lengthArray.indexOf(Math.max.apply(null, lengthArray))
    let updatedData = {}
    if(data[maxArray] != undefined){
        const reversedKeys = Object.keys(data[maxArray]).reverse();
        reversedKeys.forEach(key => {
            updatedData[key] = data[maxArray][key]
        });

    }

    const columnsToRemove = ["_id", "templateId"]; // Replace with actual column names

  // Remove unwanted columns from data
    const filteredData = data.map((row) =>
      Object.keys(row)
        .filter((key) => !columnsToRemove.includes(key)) // Exclude the columns
        .reduce((acc, key) => {
          acc[key] = row[key]; // Rebuild the filtered row
          return acc;
        }, {})
    );


    const allColumns = Object.keys(filteredData[0] || {}); // Get all column keys

    // Custom function to rearrange columns
    const arrangeColumns = () => {
      const siteLocationColumns = ["Site Name", "Location"];
      const corporateColumns = allColumns.filter((col) => col.startsWith("Corporate"));
      const otherColumns = allColumns.filter(
        (col) => !siteLocationColumns.includes(col) && !col.startsWith("Corporate") && col !== "Grand Total"
      );
      const grandTotalColumn = allColumns.includes("Grand Total") ? ["Grand Total"] : [];
  
      return [...siteLocationColumns, ...corporateColumns, ...otherColumns, ...grandTotalColumn];
    };
  
    const visibleColumns = arrangeColumns(); // Get the arranged columns
  

  const headers = Object.keys(updatedData);
  
  const updatedHeaders = type == 'fileUploadTracker' ? headers : type == 'summaryPendingData' ? ['Program Name','Status'] : type == 'summaryPivotData' ? ['Status','Count'] :visibleColumns

  // console.log(updatedHeaders,'updatedHeaders')

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  
  return (
    <Paper style={{ overflowY: 'scroll' }}>
      <Typography variant="h4" color="inherit">
        <p style={{color:'#2185d0'}}>{title}</p>
      </Typography>

      <hr />

      <Table>
        <TableHead>
          <TableRow style={{backgroundColor:'#2185d0'}}>
            {updatedHeaders.map((header) => (
              <TableCell align="left"><p style={{color:'white'}}><strong>{header.toUpperCase()}</strong></p></TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((emp, index) => (
            <StyledTableRow key={index}>
              {updatedHeaders.map((header) => (
                <TableCell align="left">
                    <p style={{'color': emp[header] === 'Applicable' ? 'red' : emp[header] === 'Not Applicable' ? 'darkgoldenrod' : String(emp[header]).includes('Received') || String(emp[header]).includes('Completed') ? 'green' :  emp[header] === 'Working in progress' ? 'orange': emp[header] === 'Pending for approval from P&G' ? 'darkgoldenrod':'black'}}><strong>{emp[header]}</strong></p>             
                </TableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

DataTable.defaultProps = {
  title: "No Title"
};

export default DataTable;

